<template>
  <div class="section">
    <div class="container">
      <!-- Client Loaded -->
      <div v-if="!loading && period !== null">
        <Breadcrumbs :history="breadcrumbs" current="Period Detail" />
        <!-- Header Loaded -->
        <div class="has-background-white rounded-lg px-lg py-md mb-xs">
          <div class="columns is-vcentered is-mobile">
            <div class="column">
              <p class="is-size-5 has-text-weight-bold">{{ $dates(period.start_date).format("MMMM YYYY") }}</p>
              <p class="has-text-grey is-size-7 has-text-grey-light">Period ID: {{ period.id }}</p>
            </div>
            <div class="column is-narrow has-text-right">
              <p class="is-size-5 has-text-weight-bold">
                <span v-if="period.closed_at" class="has-text-warning">Closed</span>
                <span v-else class="has-text-success">Open</span>
              </p>
            </div>
          </div>
        </div>
        <!-- Actions -->
        <div class="has-background-white rounded-lg px-lg py-md mb-lg">
          <div class="columns">
            <div class="column is-one-quarter">
              <b-button
                size="is-medium"
                type="is-light"
                expanded>
                Close Month
              </b-button>
            </div>
          </div>
        </div>
        <!-- Layout -->
        <div class="columns">
          <!-- Billing Menu -->
          <div class="column is-narrow">
            <b-menu class="pr-lg">
              <b-menu-list label="Client Menu">
                <b-menu-item
                  icon="clipboard-outline"
                  label="Summary"
                  tag="router-link"
                  :to="{ name: 'network.finance.period.summary', params: { code: context.code, id: period.id } }"
                  exact
                ></b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
          <!-- Partner Content -->
          <div class="column">
            <div>
              <router-view v-if="period !== null" :period="period" />
            </div>
          </div>
        </div>
      </div>
      <!-- Loading Skeleton -->
      <div v-else>
        <Loading message="Loading biling period details..." />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  computed: {
    ...mapGetters(['api', 'context']),
    breadcrumbs () {
      return [
        { label: 'Billing Periods', name: 'network.finance.periods', params: { code: this.context.code } }
      ]
    },
    endpoint () {
      return this.api.route + '/admin/billing-periods/' + this.$route.params.id
    }
  },
  data: function () {
    return {
      loading: true,
      period: null
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http.get(this.endpoint).then(response => {
        this.period = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
